// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.side-navigation {
  background: #fff;
}
.page-links-wrapper {
  margin-top: 16px;
  position: relative;
  padding: 0 20px;
}
.page-links-wrapper:before {
  content: "";
  position: absolute;
  height: 100%;
  width: 1px;
  background: #d6d6d6;
  top: 8px;
  left: 35px;
}
.sideNavLink {
  color: #505050;
  font-size: 14px;
  display: inline-block;
  padding: 10px 6px 10px 40px;
  line-height: 1.2;
  z-index: 1;
  border-radius: 6px;
  position: relative;
  margin-bottom: 2px;
  transition: all 0.4s;
  -ms-transition: all 0.4s;
  -webkit-transition: all 0.4s;
  -moz-transition: all 0.4s;
}
.sideNavLink.active,
.sideNavLink:hover {
  background: #e5f1f8;
  font-weight: 600;
}
.sideNavLink:before {
  content: "";
  position: absolute;
  height: 20px;
  width: 20px;
  position: absolute;
  left: 6px;
  top: 8px;
  border-radius: 50%;
  background: #fff;
  border: 1px solid rgb(224, 224, 224);
}
.sideNavLink:after {
  content: "";
  position: absolute;
  height: 9px;
  width: 5px;
  border-right: 1px solid #fff;
  left: 13px;
  top: 12px;
  transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  border-bottom: 1px solid #fff;
}
.sideNavLink.page-visited {
  font-weight: 600;
}
.sideNavLink.page-visited:before {
  border-color: 1px solid #0177b5;
  background: #0177b5;
}
.sideNavLink.page-visited:after {
  border-bottom-color: #fff;
  border-right-color: #fff;
}
.button:disabled {
  cursor: not-allowed;
}
.so-btn-container {
  border-bottom: 1px solid #999999;
  display: flex;
  align-items: center;
  padding:0 12px 10px;
}
.application-fillout-link {
  cursor: pointer;
  width: 100%;
  text-align: center;
  display: block;
  padding: 10px 20px;
  background: #0177b5;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  z-index: 1;
  position: relative;
}
.application-fillout-link > img {
  margin-right: 5px;
}
.sub-section {
  margin-left: 25px;
}
.highlightUnfilledSection .unfilledSection {
  color: #e0a633;
  font-weight: 400;
}
.highlightUnfilledSection .sideNavLink.unfilledSection:before {
  background: #fff;
  border: 1px solid #e0a633;
}
.highlightUnfilledSection .sideNavLink.unfilledSection:after {
  border: none;
  content: "i";
  color: #e0a633;
  transform: rotate(0);
  -ms-transform: rotate(0);
  -webkit-transform: rotate(0);
  -moz-transform: rotate(0);
  top: 10px;
  left: 14px;
  font-weight: bold;
}
.sideNavLink.pageLinkUi__disabled {
  color: #777874;
  font-weight: 600;
}
.sideNavLink.pageLinkUi__disabled:before {
  background: #777874;
  border-color: #777874;
}
.so-btn {
  padding:6px;
  width:100%;
  text-align: center;
}
.highlight--prioritySections {
  display: flex;
  display: -webkit-flex;
  padding: 15px 2px 15px 8px;
  border-bottom: 1px solid #999999;
}
.highlight--prioritySections__label {
  font-size: 14px;
  font-weight: 600;
  color: #354fcb;
}
.highlight--prioritySections__text {
  color: #000;
}
.highlight--prioritySections__checkbox {
  margin: 0 3px 0 0;
}
.show-highlighted {
  position: relative;
}
.rpiq--label {
  display: none;
}
.show-highlighted .rpiq--label {
  font-weight: 700;
  color: #354fcb;
  font-size: 12px;
  display: inline-block;
}
`, "",{"version":3,"sources":["webpack://./src/components/sideNav/SideNav.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,QAAQ;EACR,UAAU;AACZ;AACA;EACE,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,2BAA2B;EAC3B,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,wBAAwB;EACxB,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;;EAEE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;AACtC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,4BAA4B;EAC5B,UAAU;EACV,SAAS;EACT,wBAAwB;EACxB,4BAA4B;EAC5B,gCAAgC;EAChC,6BAA6B;EAC7B,6BAA6B;AAC/B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,wBAAwB;EACxB,4BAA4B;EAC5B,yBAAyB;EACzB,SAAS;EACT,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,0BAA0B;EAC1B,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB","sourcesContent":[".side-navigation {\n  background: #fff;\n}\n.page-links-wrapper {\n  margin-top: 16px;\n  position: relative;\n  padding: 0 20px;\n}\n.page-links-wrapper:before {\n  content: \"\";\n  position: absolute;\n  height: 100%;\n  width: 1px;\n  background: #d6d6d6;\n  top: 8px;\n  left: 35px;\n}\n.sideNavLink {\n  color: #505050;\n  font-size: 14px;\n  display: inline-block;\n  padding: 10px 6px 10px 40px;\n  line-height: 1.2;\n  z-index: 1;\n  border-radius: 6px;\n  position: relative;\n  margin-bottom: 2px;\n  transition: all 0.4s;\n  -ms-transition: all 0.4s;\n  -webkit-transition: all 0.4s;\n  -moz-transition: all 0.4s;\n}\n.sideNavLink.active,\n.sideNavLink:hover {\n  background: #e5f1f8;\n  font-weight: 600;\n}\n.sideNavLink:before {\n  content: \"\";\n  position: absolute;\n  height: 20px;\n  width: 20px;\n  position: absolute;\n  left: 6px;\n  top: 8px;\n  border-radius: 50%;\n  background: #fff;\n  border: 1px solid rgb(224, 224, 224);\n}\n.sideNavLink:after {\n  content: \"\";\n  position: absolute;\n  height: 9px;\n  width: 5px;\n  border-right: 1px solid #fff;\n  left: 13px;\n  top: 12px;\n  transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  -webkit-transform: rotate(45deg);\n  -moz-transform: rotate(45deg);\n  border-bottom: 1px solid #fff;\n}\n.sideNavLink.page-visited {\n  font-weight: 600;\n}\n.sideNavLink.page-visited:before {\n  border-color: 1px solid #0177b5;\n  background: #0177b5;\n}\n.sideNavLink.page-visited:after {\n  border-bottom-color: #fff;\n  border-right-color: #fff;\n}\n.button:disabled {\n  cursor: not-allowed;\n}\n.so-btn-container {\n  border-bottom: 1px solid #999999;\n  display: flex;\n  align-items: center;\n  padding:0 12px 10px;\n}\n.application-fillout-link {\n  cursor: pointer;\n  width: 100%;\n  text-align: center;\n  display: block;\n  padding: 10px 20px;\n  background: #0177b5;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n  z-index: 1;\n  position: relative;\n}\n.application-fillout-link > img {\n  margin-right: 5px;\n}\n.sub-section {\n  margin-left: 25px;\n}\n.highlightUnfilledSection .unfilledSection {\n  color: #e0a633;\n  font-weight: 400;\n}\n.highlightUnfilledSection .sideNavLink.unfilledSection:before {\n  background: #fff;\n  border: 1px solid #e0a633;\n}\n.highlightUnfilledSection .sideNavLink.unfilledSection:after {\n  border: none;\n  content: \"i\";\n  color: #e0a633;\n  transform: rotate(0);\n  -ms-transform: rotate(0);\n  -webkit-transform: rotate(0);\n  -moz-transform: rotate(0);\n  top: 10px;\n  left: 14px;\n  font-weight: bold;\n}\n.sideNavLink.pageLinkUi__disabled {\n  color: #777874;\n  font-weight: 600;\n}\n.sideNavLink.pageLinkUi__disabled:before {\n  background: #777874;\n  border-color: #777874;\n}\n.so-btn {\n  padding:6px;\n  width:100%;\n  text-align: center;\n}\n.highlight--prioritySections {\n  display: flex;\n  display: -webkit-flex;\n  padding: 15px 2px 15px 8px;\n  border-bottom: 1px solid #999999;\n}\n.highlight--prioritySections__label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #354fcb;\n}\n.highlight--prioritySections__text {\n  color: #000;\n}\n.highlight--prioritySections__checkbox {\n  margin: 0 3px 0 0;\n}\n.show-highlighted {\n  position: relative;\n}\n.rpiq--label {\n  display: none;\n}\n.show-highlighted .rpiq--label {\n  font-weight: 700;\n  color: #354fcb;\n  font-size: 12px;\n  display: inline-block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
